import React, { useEffect, useState } from "react";
import axios from "axios";

import { GET_FUNCTIONAL_GRANTED_PRODUCTS, APP_BASE_URL } from "../../AppConstant";
import { red } from "@mui/material/colors";

import LoadingGif from "../../../assets/images/Spin_loader.gif"


function FunctionalGrantedProducts({ setParentLoading }) {

    const [grantedProducts, setGrantedProducts] = useState([]);

    const GrantedProducts = async () => {

        try {
              setParentLoading(true);

            const email = localStorage.getItem("emailid");

            console.log("Email:", email);


            const res = await axios.get(GET_FUNCTIONAL_GRANTED_PRODUCTS,{
                params: { email }
            });
            setGrantedProducts(res.data);
            console.log("API response:", res.data);
              setTimeout(() => {
            setParentLoading(false);
        }, 500);
        } catch (err) {
              setTimeout(() => {
            setParentLoading(false);
        }, 500);
            console.error(err);
        }
    };

    useEffect(() => {
        GrantedProducts();
    }, []);

    const generateGrantId = (item) => {
    const date = new Date(item.granted_at);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");

    const paddedId = String(item.granted_id).padStart(4, "0");
    const cleanName = item.product_name.replace(/\s+/g, "");

     return `AST-${cleanName}-${paddedId}`;
};

 const generateRequestId = (item) => {
        const date = new Date(item.requested_at);

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");

        const paddedId = String(item.request_id).padStart(4, "0");

        return `ACC-${year}${month}-${paddedId}`;
    };


      const [searchTerm, setSearchTerm] = useState("");
        
            const filteredProducts = grantedProducts.filter((item) => {
            const searchableText = [
                ...Object.values(item),
                generateRequestId(item),
                generateGrantId(item)
            ]
                .join(" ")
                .toLowerCase();
        
            return searchableText.includes(searchTerm.toLowerCase());
        });
        


    return (
        <>
        <div>
            <div className="input-group mb-3" style={{ width: "500px" }}>
    <span className="input-group-text">
        <i className="bi bi-search"></i>
    </span>

    <input
        type="text"
        className="form-control"
        placeholder="Search..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
    />
</div>


            <table className="mt-3 fw-bold">
                <thead className="bg-primary" style={{color:"var(--bs-white)"}} >
                    <tr>
                        <th>S.No</th>
                        <th>REQUEST ID</th>
                        <th>GRANT ID</th>
                        <th>EMPLOYEE ID </th>
                        <th>EMPLOYEE NAME </th>
                        <th>EMPLOYEE EMAIL </th>
                        <th>PRODUCT NAME</th>
                        <th>GRANTED AT</th>
                    </tr>
                </thead>

                <tbody className="text-secondary" style={{fontSize:"small"}}>
                    {filteredProducts.length > 0 ? (
                        filteredProducts.map((item, index) => (
                            <tr key={item.granted_id}>

                                <td>{index + 1}</td>
                                <td>{generateRequestId(item)}</td>
                                <td>{generateGrantId(item)}</td>
                                <th>{item.employee_id}</th>
                                <th>{item.employee_name}</th>
                                <th>{item.employee_email}</th>
                                <td>{item.product_name}</td>

                        <td>
  {new Date(item.granted_at.replace(" ", "T"))
    .toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric"
    })
    .replace(",", "")}
</td>

                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="9" style={{ textAlign: "center" }}>
                                No products available
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>


</>

    );
}

export default FunctionalGrantedProducts;